import { Card, CardBody, CardHeader, Heading, HStack, Text, VStack, WhiteCard } from '@elkaso-app/web-design';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Colors,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import React, { useEffect } from 'react';
import { changeTitle } from 'redux/actions';
import { useAppDispatch } from 'redux/hooks';
import {
  ProductsCategoriesCountsData,
  useGetProductsCategoriesCountsApi,
} from '../../../apis/analytics/use-get-products-categories-counts-api';
import { ProductsCategoriesCountsPieChart } from '../components/products-categories-counts-pie-chart';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend, Colors);

export const AnalyticsProductDashboardScreen = () => {
  const dispatch = useAppDispatch();
  const { data: productsCategoriesCountsData } = useGetProductsCategoriesCountsApi();

  useEffect(() => {
    dispatch(changeTitle('sidebar.analytics'));
  }, []);

  interface OrdersChartDataProps {
    categoriesCountsData: ProductsCategoriesCountsData[];
  }

  const productsChartProps = React.useMemo((): OrdersChartDataProps => {
    return {
      categoriesCountsData: (productsCategoriesCountsData || []) as ProductsCategoriesCountsData[],
    };
  }, [productsCategoriesCountsData]);

  return (
    <HStack maxWidth={'full'} overflow={'hidden'} spacing='md' align='stretch' h='full'>
      <WhiteCard display={'flex'} flexDirection={'column'} width={'full'} overflow={'auto'}>
        <VStack padding={3} align='normal' h='full'>
          <HStack mb={'20'}>
            <Card boxShadow='md' borderRadius='lg'>
              <CardHeader>
                <Text fontSize='lg' fontWeight='bold' color='gray.600'>
                  Uncategorized Products
                </Text>
              </CardHeader>
              <CardBody p={6} textAlign='center'>
                <Heading as='h2' size='2xl' color='red.500'>
                  200
                </Heading>
              </CardBody>
            </Card>
          </HStack>
          <ProductsCategoriesCountsPieChart data={productsChartProps.categoriesCountsData} />
        </VStack>
      </WhiteCard>
    </HStack>
  );
};
